/**
   Copyright (c)2021 3Key Company s.r.o., All Rights Reserved

   It is strictly prohibited to distribute the source code,
   transpiled and compiled code or its parts without previous
   agreement of the 3Key Company board.
*/

import "./CompanySettings.css";

import React from "react";

import { CompanySettingsProps, CompanySettingsState } from "./CompanySettings.types";

import VTab, { VTabPage } from "components/ThreeKey/VTab";

import CompanyDetails from "./CompanyDetails/CompanyDetails";
import UsersGroups from "./UsersGroups/UsersGroups";
import CveTags from "./CveTags/CveTags";
import LicenseBilling from "./LicenseBilling/LicenseBilling";

import Dialog from "components/ThreeKey/Dialogs/Dialog";
import MessageBox from "components/ThreeKey/Dialogs/MessageBox";

export default class CompanySettings extends React.Component<CompanySettingsProps, CompanySettingsState> {

   private canSwitchTab?: Promise<boolean>;
   private canSwitchTabReslove?: (value: boolean) => void;

   constructor (props: CompanySettingsProps) {

      super(props);

      this.state = {
         closeConfirmDialogDisplayed: false,
         companyDataChanged: false
      }

   }

   public render(): React.ReactNode {

      const tabs: VTabPage[] = [

         {
            label: "Company details",
            content: <CompanyDetails notifyDataChanges={ changed => { setTimeout(() => { this.setState({ companyDataChanged: changed }) }, 0) } }/>
         },
         {
            label: "Users & Groups",
            content: <UsersGroups />
         },
         {
            label: "CVE Tags",
            disabled: true,
            content: <CveTags />
         },
         {
            label: "Licensing & Billing",
            disabled: true,
            content: <LicenseBilling />
         }

      ];

      const closeConfirmDialog = this.state.closeConfirmDialogDisplayed ?

         <MessageBox
            cancelOnEscape={true}
            cancelOnOverlayMouseDown={true}
            okText={"Discard"}
            onOk={this.onDicardDialogDiscardClick}
            hasCancel={true}
            onCancel={this.onDicardDialogCancelClick}
            caption={"There are unsaved changes in the form"}
            message={"Do you want to discard them?"}
         />

      :
         <></>

      return (

         <div className="company-settings-dialog">

            <Dialog closeOnEscape={true} closeOnOverlayMouseDown={true} onClose={this.onClose}>
               <VTab componentName="company-settings" tabs={tabs} onBeforeTabSwitch={this.onBeforeTabSwitch} />
            </Dialog>

            {closeConfirmDialog}

         </div>

      )

   }

   private onBeforeTabSwitch = (currentIndex: number, newIndex: number): boolean | Promise<boolean> => {

      switch(currentIndex) {

         case 0:
            if (!this.state.companyDataChanged) return true;
            this.setState({ closeConfirmDialogDisplayed: true });
            this.canSwitchTab = new Promise((resolve) => { this.canSwitchTabReslove = resolve });
            return this.canSwitchTab;

         case 1:
            return true;

         default:
            return false; // this is just if tabs are added or removed, incorred function must be detected during testing

      }

   }

   private onClose = () => {

      if (this.state.companyDataChanged) {
         this.setState({ closeConfirmDialogDisplayed: true });
         return;
      }

      this.props.onClose();

   }

   private onDicardDialogDiscardClick = () => {

      this.setState({
         closeConfirmDialogDisplayed: false,
         companyDataChanged: false
      });

      if (this.canSwitchTab && this.canSwitchTabReslove) {
         setTimeout(() => {
            this.canSwitchTabReslove!(true);
            this.canSwitchTab = undefined;
            this.canSwitchTabReslove = undefined;
         }, 0);
      } else {
         setTimeout(() => { this.props.onClose() }, 0);
      }

   }

   private onDicardDialogCancelClick = () => {

      this.setState({ closeConfirmDialogDisplayed: false });

      if (this.canSwitchTab && this.canSwitchTabReslove) {
         setTimeout(() => {
            this.canSwitchTabReslove!(false);
            this.canSwitchTab = undefined;
            this.canSwitchTabReslove = undefined;
         }, 0);
      }

   }

}
